<template>
  <v-checkbox
    v-if="currentDoctor"
    :model-value="modelValue"
    :label="`自分（${currentDoctor.name}）の回答のみ表示`"
    class="mt-1 mr-3 c-checkbox--mini"
    density="compact"
    hide-details
    :data-test="dataTest"
    :true-value="currentDoctor.id"
    :false-value="null"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
export default {
  name: "OnlyMyAnswerCheckbox",

  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    currentDoctor: {
      type: Object,
      default: null
    },
    dataTest: {
      type: String,
      default: "onlyMyAnswer-checkbox"
    }
  },

  emits: ["update:modelValue"]
};
</script>
